// Shared positioning for the flow-book tooltips so the bubble/cell readout stays
// fully on-screen. Bookmap Pro/Sandbox and Bookmap use the cursor-
// following `tipFollowStyle`; the legacy Flow Book bubble tip uses `tipCenteredLeft`.

function clamp(v, lo, hi) {
  return Math.max(lo, Math.min(hi, v));
}

// Cursor-following tooltip: centered horizontally on the cursor and placed just
// below it, then clamped so the whole box stays inside `region` on every side.
// Near an edge the box stops against it and the cursor rides over it (same on all
// four sides). `box` is the measured { w, h }; `region` is { left, right, top,
// bottom } in the same coordinate space as the cursor. Returns a style object
// (uses translateX(-50%) for the horizontal centering).
export function tipFollowStyle(cursorX, cursorY, region, box, opts = {}) {
  const { gap = 16 } = opts;
  const halfW = box.w / 2;
  return {
    left: clamp(cursorX, region.left + halfW, region.right - halfW),
    top: clamp(cursorY + gap, region.top, region.bottom - box.h),
    transform: 'translateX(-50%)',
  };
}

// Strike-centered tooltip (Flow Book): the CSS centers it on the strike via
// translateX(-50%); clamp the center so neither edge of the box leaves the panel.
export function tipCenteredLeft(cx, width, halfW) {
  return Math.max(halfW + 2, Math.min(width - halfW - 2, cx));
}

export function shouldRenderUpperStrikeFirst(upperValue, lowerValue, upperY, lowerY) {
  const a = upperValue == null ? NaN : Number(upperValue);
  const b = lowerValue == null ? NaN : Number(lowerValue);
  if (Number.isFinite(a) && Number.isFinite(b)) return a >= b;
  return Number(upperY) <= Number(lowerY);
}
